// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import * as Turbo from "@hotwired/turbo"
window.Turbo = Turbo
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap

import "cocoon-js"
import "jquery"
// import "rails_admin"
